import Bus from "@/lib/Bus"
const bus: Bus = new Bus().getBus();
import { IIdx } from "./IIdx";
import {IIdxSvc,idx_api} from "./IIdxSvc"


export class IdxSvc implements IIdxSvc {

    public async update_idx(idx: IIdx): Promise<IIdx | undefined> {
        const ret = await bus.call(idx_api.update_idx,idx);
        if (ret && ret._id) return (<IIdx> ret);
        else return undefined
    }

    public async find_by_id(_id: any): Promise<IIdx | undefined> {
        const ret = await bus.call(idx_api.find_by_id,{_id:_id});
        if (ret && ret._id) return (<IIdx> ret);
        else return undefined
    }

    public async create_nowy_w_erp(idx: IIdx): Promise<IIdx | undefined>
    {
        const ret = await bus.call(idx_api.create_nowy_w_erp,idx);
        if (ret) return (<IIdx> ret);
        else return undefined
    }
    public async create_korekta_w_erp(idx: IIdx): Promise<IIdx | undefined>
    {
        const ret = await bus.call(idx_api.create_korekta_w_erp,idx);
        if (ret) return (<IIdx> ret);
        else return undefined
    }

    public async create_nowy_w_erp_full(idx: IIdx): Promise<IIdx | undefined>
    {
        const ret = await bus.call(idx_api.create_nowy_w_erp_full,idx);
        if (ret) return (<IIdx> ret);
        else return undefined
    }
    public async create_korekta_w_erp_full(idx: IIdx): Promise<IIdx | undefined>
    {
        const ret = await bus.call(idx_api.create_korekta_w_erp_full,idx);
        if (ret) return (<IIdx> ret);
        else return undefined
    }


    public async update_w_erp(idx: IIdx): Promise<IIdx | undefined>
    {
        const ret = await bus.call(idx_api.update_w_erp, idx);
        if (ret) return (<IIdx> ret);
        else return undefined
    }

   

    public async get_by_wytwor_idm(nr_etykiety: string):Promise<IIdx | undefined> 
    {
        const ret = await bus.call(idx_api.get_by_wytwor_idm, {_id: nr_etykiety });
        if (ret) return (<IIdx> ret);
        else return undefined
    }

}
      
  